<ng-container>
    <h1>
        {{ 'DEVICE_CODE_FLOW.CODE_SUCCESS.CODE_SUCCESS_MSG' | translate }}
    </h1>
    <div class="device-logo">
        <img class="logo" src="assets/img/alert-success.svg" alt="">
    </div>
    <p>
        {{ 'DEVICE_CODE_FLOW.CODE_SUCCESS.CODE_CONTINUE_MSG' | translate }}
    </p>
</ng-container>